<template>
    <div class="mt-6 px-6">
        <h3 class="text-subheading font-semibold">
            {{ $t('itemModal.nutritionBreakdown') }}
        </h3>

        <div class="mt-4 space-y-1">
            <!-- Energy (kcal) -->
            <div
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0"
            >
                <span class="text-sm font-medium">{{
                    $t('itemModal.energyKcal')
                }}</span>
                <span class="text-sm text-muted">{{ totalCalories }}</span>
            </div>

            <!-- Energy (kJ) -->
            <div
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0"
            >
                <span class="text-sm font-medium">{{
                    $t('itemModal.energyKj')
                }}</span>
                <span class="text-sm text-muted">{{ energyKj }}</span>
            </div>

            <!-- Fats -->
            <div
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0"
            >
                <span class="text-sm font-medium">{{
                    $t('itemModal.fats')
                }}</span>
                <span class="text-sm text-muted">{{ totalFats }}g</span>
            </div>

            <!-- of which saturates -->
            <div
                v-if="totalFatSaturates !== null"
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0 pl-4"
            >
                <span class="text-sm text-muted">{{
                    $t('itemModal.ofWhichSaturates')
                }}</span>
                <span class="text-sm text-muted">{{ totalFatSaturates }}g</span>
            </div>

            <!-- Carbs -->
            <div
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0"
            >
                <span class="text-sm font-medium">{{
                    $t('itemModal.carbohydrates')
                }}</span>
                <span class="text-sm text-muted">{{ totalCarbs }}g</span>
            </div>

            <!-- of which sugars -->
            <div
                v-if="totalCarbsSugars !== null"
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0 pl-4"
            >
                <span class="text-sm text-muted">{{
                    $t('itemModal.ofWhichSugars')
                }}</span>
                <span class="text-sm text-muted">{{ totalCarbsSugars }}g</span>
            </div>

            <!-- Proteins -->
            <div
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0"
            >
                <span class="text-sm font-medium">{{
                    $t('itemModal.protein')
                }}</span>
                <span class="text-sm text-muted">{{ totalProtein }}g</span>
            </div>

            <!-- Fibres -->
            <div
                v-if="totalFibre !== null"
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0"
            >
                <span class="text-sm font-medium">{{
                    $t('itemModal.fibres')
                }}</span>
                <span class="text-sm text-muted">{{ totalFibre }}g</span>
            </div>

            <!-- Salt -->
            <div
                v-if="totalSalt !== null"
                class="flex justify-between items-center py-2 border-b border-dashed border-gray-200 last:border-b-0"
            >
                <span class="text-sm font-medium">{{
                    $t('itemModal.salt')
                }}</span>
                <span class="text-sm text-muted">{{ totalSalt }}g</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NutritionBreakdownTable',
    props: {
        totalCalories: {
            type: Number,
            default: 0
        },
        totalCarbs: {
            type: Number,
            default: 0
        },
        totalFats: {
            type: Number,
            default: 0
        },
        totalProtein: {
            type: Number,
            default: 0
        },
        totalSalt: {
            type: Number,
            default: null
        },
        totalFibre: {
            type: Number,
            default: null
        },
        totalCarbsSugars: {
            type: Number,
            default: null
        },
        totalFatSaturates: {
            type: Number,
            default: null
        }
    },
    computed: {
        energyKj() {
            return Math.round(this.totalCalories * 4.184);
        }
    }
};
</script>
